import { createModule } from 'saga-slice';
import { crudReducers } from 'saga-slice-helpers';
import { sagaApi } from '#/apis';
import { takeLatest } from 'redux-saga/effects';
import { sagaSuccess, sagaFail } from '+/sagas';


const sagaSlice = createModule({

    name: 'lawyers',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    reducers: crudReducers({}),

    sagas: A => ({

        [A.create]: {
            *saga ({ payload }) {

                yield sagaApi.post(
                    '/lawyers',
                    payload,
                    A.createSuccess,
                    A.createFail
                );
            }
        },
        [A.delete]: {
            *saga ({ payload: id }) {

                yield sagaApi.delete(
                    `/lawyers/${id}`,
                    null,
                    A.deleteSuccess,
                    A.deleteFail
                );
            }
        },
        [A.update]: {
            *saga ({ payload }) {
                const { id } = payload;

                yield sagaApi.put(
                    `/lawyers/${id}`,
                    payload,
                    A.updateSuccess,
                    A.updateFail
                );
            }
        },
        [A.readOne]: {
            *saga ({ payload: id }) {

                yield sagaApi.get(
                    `/lawyers/${id}`,
                    A.readOneSuccess,
                    A.readOneFail
                );
            },
            taker: takeLatest
        },
        [A.readAll]: {
            *saga () {

                yield sagaApi.get(
                    'lawyers',
                    A.readAllSuccess,
                    A.readAllFail
                );
            },
            taker: takeLatest
        },


        [A.createSuccess]: sagaSuccess('Lawyer created', '/lawyers'),
        [A.deleteSuccess]: sagaSuccess('Lawyer deleted'),
        [A.updateSuccess]: sagaSuccess('Lawyer data updated'),

        [A.createFail]: sagaFail('', '/lawyers'),
        [A.deleteFail]: sagaFail(),
        [A.updateFail]: sagaFail()
    })
});

export const { actions } = sagaSlice;
export default sagaSlice;
